import { Link } from 'react-router-dom'; 

const HeaderHyfye = () => {
    return ( 
    <>
     
    <div className="container-fluid">
        
		<nav className="navbar navbar-expand-lg"> 
             <Link className="navbar-brand page-scroll animation logo" to="/#home_section" data-animation="fadeInDown" data-animation-delay="0.1s"> 
            	
                <img className="logo_dark App-logo" src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/web/logo-dark.png" loading="lazy" alt="logo" /> 
                <img className='logo_light App-logo' src='https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/web/logo-white.png' loading="lazy" alt='logo'/>
             </Link>
            <button className="navbar-toggler animation bluecolor" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" data-animation="fadeInDown" data-animation-delay="0.1s"> 
                <span className="ion-android-menu"></span> 
            </button>
			<div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav m-auto">
                    <li className="animation" data-animation="fadeInDown" data-animation-delay="0.1s">
						<Link className="nav-link page-scroll nav_item " to="/#home_section">Home</Link>
					</li>
                    <li className="animation" data-animation="fadeInDown" data-animation-delay="0.1s">
                        <Link className="nav-link page-scroll nav_item active" target='blank' to="https://www.freshcoins.io/coins/hyfye">Audit</Link>
                    </li>
                    <li className="animation" data-animation="fadeInDown" data-animation-delay="0.1s">
                        <Link className="nav-link page-scroll nav_item" to="/#about">About</Link></li>
                    <li className="animation" data-animation="fadeInDown" data-animation-delay="0.1s">
                        <Link className="nav-link page-scroll nav_item" to="/#how_it_work">How It Work</Link></li>
                    <li className="animation" data-animation="fadeInDown" data-animation-delay="0.1s">
                        <Link className="nav-link page-scroll nav_item" to="/#token">Token</Link></li>
                    
                    <li className="animation" data-animation="fadeInDown" data-animation-delay="0.1s">
                         <Link className="nav-link page-scroll nav_item" to="/#roadmap">Road Map</Link>
                    </li>
                   
                    <li className="animation" data-animation="fadeInDown" data-animation-delay="0.1s">
                        <Link className="nav-link page-scroll nav_item" to="/#team">Team</Link></li>
                    <li className="animation" data-animation="fadeInDown" data-animation-delay="0.45s"><Link className="nav-link page-scroll nav_item" to="/#faq">FAQ</Link></li>
                    <li className="animation" data-animation="fadeInDown" data-animation-delay="0.45s"><Link className="nav-link page-scroll nav_item" to="/#contact">Contact</Link></li>
                </ul>
                 <ul className="navbar-nav nav_btn align-items-center">
                    <li className="animation" data-animation="fadeInDown" data-animation-delay="0.1s">
                    </li>
                </ul>
			</div>
		</nav> 
       
	</div>  

       <div className="marquee">
      <div className="marquee-text">
       
            <span>Please Note: </span>
            <strong>Hyfye</strong> Team will never send you messages on any social networks, Please verify our social links via our website: &nbsp;&nbsp;
              <strong><a href="https://www.hyfye.com">Hyfye</a></strong> | Never Share Your Seed Phrase or Private Key with anyone. 
              <strong>
                 <span>Our Token Address: </span> <a href="https://bscscan.com/token/0xbF35945D28ff93dE8786E10Aa8e716524f43628b" target='_blank'>0xbF35945D28ff93dE8786E10Aa8e716524f43628b</a>
              </strong>
       
      </div>
 
     </div>  </>
)};

export default HeaderHyfye;